import { DEFAULT_PAPER_TYPE_ID, PAPER_TYPES } from './constants.js'

export type PaperTypeId = keyof typeof PAPER_TYPES
export type PaperType = (typeof PAPER_TYPES)[PaperTypeId]

export function getPaperType(id: PaperTypeId): PaperType {
  return PAPER_TYPES[id]
}

export function getDefaultPaperType(): PaperType {
  return PAPER_TYPES[DEFAULT_PAPER_TYPE_ID as PaperTypeId]
}

export function findPaperTypeByLabel(label: string): PaperType | undefined {
  return Object.values(PAPER_TYPES).find((type) => type.label === label || type.id === label)
}

export function findPaperTypeIdByLabel(label: string): PaperTypeId | undefined {
  const entry = Object.entries(PAPER_TYPES).find(([, type]) => type.label === label || type.id === label)
  return entry ? (entry[0] as PaperTypeId) : undefined
}
